<app-header></app-header>

    <ng-container *ngIf="accessApproval == true">
        <section class="content-box">
            <div class="tab-content" id="myTabContent">
                <!--  market Position -->
                <div class="tab-pane fade show active" id="market">
                    <div class="deta-tebal-box">
                        <!-- <div class="heading-border-box ">
                            <p>Market </p>
                        </div> -->
            
                        <div class="respo-scroll" *ngIf="marketType=='market'">
                            <table class="default-table-style">
                                <thead>
                                    <tr >
                                        <th class="text-left sortable" (click)="sortFields('exchange')" id="exchange" data-sort = "asc">Exch</th>
                                        <th class="text-left sortable" (click)="sortFields('name')" id="name" data-sort = "asc">Instrument</th>
                                        <th class="text-left sortable"  (click)="sortFields('expiry')" id="expiry" data-sort = "asc">Expiry</th>
                                        <th class="text-center">Buy</th>
                                        <th class="text-center">Sell</th>
                                        <th class="text-center">Net Chg</th>
                                        <th class="text-center">High</th>
                                        <th class="text-center">Low</th>                                    
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- *ngFor="let img of bannerImages; let i = index;" -->
                                    <tr *ngFor="let brec of badlaRecord; let i = index;" >
                                      <td class="d-none"> 
                                         <input type="hidden" id="{{brec.instrument_token}}_prevBuy">
                                        <input type="hidden" id="{{brec.instrument_token}}_prevSell">
                                        <input type="hidden" id="{{brec.instrument_token}}_prevNet">
                                    </td>
                                        
                                        <td class="text-left mani-tevl">{{brec.exchange}}</td>
                                        <td>{{brec.name}}</td>
                                        <td>{{brec.expiry}}</td>
                                        <td class="text-center buy " id="{{brec.instrument_token}}_buyprice">0</td>
                                        <td class="text-center buy" id="{{brec.instrument_token}}_sellprice">0</td>
                                        <td class="text-center buy" id="{{brec.instrument_token}}_net_change">0</td>
                                        <td class="text-center buy" id="{{brec.instrument_token}}_high">0</td>
                                        <td class="text-center buy" id="{{brec.instrument_token}}_low">0</td>
                                        
                                    </tr>                               
                                </tbody>
                            </table>
                        </div>
                        <!-- <div class="respo-scroll" *ngIf="marketType=='livebadla'">
                            <table class="default-table-style">
                                <thead>
                                    <tr >
                                        <th class="text-left">Symbol</th>
                                        <th class="text-left">Month1</th>
                                        <th class="text-left">COMEX</th>
                                        <th class="text-left">Price</th>
                                        <th class="text-left">MCX</th>
                                        <th class="text-left">Price</th>
                                        <th class="text-left">DGCX</th>
                                        <th class="text-left">Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let binstu of badlaInstruments; let i = index;">
                                        <input type="hidden" id="{{binstu._id}}_prev_finalBadla">
                                        <td class="text-left">{{binstu.instrumentsDetail[0].name}}</td>
                                        <td class="text-left" id="{{binstu._id}}"></td>
                                        <td class="text-left">{{binstu.instrumentsDetail[0].expiry}}</td>
                                        <td class="text-left"><span class="{{binstu.instrumentsDetail[0].instrument_token}}_badla_buyP">0</span> | <span class="{{binstu.instrumentsDetail[0].instrument_token}}_badla_sellP">0</span></td>
                                        <td class="text-left">{{binstu.instrumentsDetail[1].expiry}}</td>
                                        <td class="text-left"><span class="{{binstu.instrumentsDetail[1].instrument_token}}_badla_buyP">0</span> | <span class="{{binstu.instrumentsDetail[1].instrument_token}}_badla_sellP">0</span></td>
                                        <td class="text-left">{{binstu.instrumentsDetail[2].expiry}}</td>
                                        <td class="text-left"><span class="{{binstu.instrumentsDetail[2].instrument_token}}_badla_buyP">0</span> | <span class="{{binstu.instrumentsDetail[2].instrument_token}}_badla_sellP">0</span></td>
                                    </tr>                               
                                </tbody>
                            </table>
                        </div> -->
    
                    </div>
                </div>
                <!-- badle settig -->
                <div class="tab-pane fade" id="badle">
                   1 
                </div>
                <!--  settig Report -->
                <div class="tab-pane fade" id="settig">
                    2
                </div>
                <!-- porfile Summary -->
                <div class="tab-pane fade" id="porfile">
                  3 
                </div>
    
    
            </div>
           
        </section>
        <app-footer></app-footer>
    </ng-container>
    <ng-container *ngIf="accessApproval == false">
        <div class="alert alert-danger" role="alert">
            You can not access this panel.
          </div>
    </ng-container>
